import { getMatrixFromXLS } from './utils/getMatrixFromXLS.js';
import { matrixToBlocks } from './utils/matrixToBlocks.js';
import { parseBETSurfaceAreaPlot } from './utils/parseBETSurfaceAreaPlot.js';
import { parseHeader } from './utils/parseHeader.js';
import { parseSurfaceArea } from './utils/parseSurfaceArea.js';
import { parseTPlot } from './utils/parseTPlot.js';
import { parseTPlotReport } from './utils/parseTPlotReport.js';
import { parseTPlotReportData } from './utils/parseTPlotReportData.js';

export function betParseGemini(blob) {
  let result = {};
  const matrix = getMatrixFromXLS(blob);
  const blocks = matrixToBlocks(matrix);
  if (blocks.length === 0) {
    throw new Error('betParseGemini error: no blocks found');
  }
  if (!blocks[0].header) {
    throw new Error('betParseGemini: first block does not contain meta info');
  }
  result.header = parseHeader(blocks[0].header);
  result.surfaceArea = parseSurfaceArea(blocks);
  result.betSurfaceAreaPlot = parseBETSurfaceAreaPlot(blocks);
  result.tPlotReport = parseTPlotReport(blocks);
  result.tPlotReportData = parseTPlotReportData(blocks);
  result.tPlot = parseTPlot(blocks);

  return result;
}
